import { FC } from "react";
import logo from "@assets/icons/logo.svg";

interface LogoProps {
    size?: number;
    className?: string;
    onClick?: () => void;
}

export const Logo: FC<LogoProps> = ({ size = 50, className, onClick }) => {
    return (
        <div
            className={`flex items-center justify-center ${className || ""}`}
            style={{
                width: `${size}px`,
                height: `${size}px`,
            }}
            onClick={onClick}
        >
            <img
                src={logo}
                alt="Logo"
                className="object-contain"
                style={{ width: `${size}px`, height: `${size}px` }}
            />
        </div>
    );
};
